<template lang="pug">
	.animated.fadeIn.preview-screen(v-if="Template.SelectedTemplate && Project.SelectedProject")
		.controls
			.left-controls
				//.control-button(v-if="Layout.layout === 'dashboard'" v-on:click="openPreview" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Open public preview link'}")
					i.fa.fa-share-square
				//select.custom-select.custom-select-sm(v-on:input="setWebsite($event.target.value)" v-on:change="setWebsite($event.target.value)")
					option(:selected="domain === 'none'" value="none") Testing
					option(:selected="domain === siteProps.domain" :value="siteProps.domain" v-for="siteProps in availableWebsites") {{siteProps.domain}}
				.global-search-wrapper#global-search-wrapper
					.global-search(:class="{'filter-exists': globalSearchFilter && globalSearchFilter.length}")
						i.fa.fa-search
						input.search-input(ref="input" placeholder="Global search" v-model="globalSearchFilter" @click="showGlobalSearch" :style="{'width': '220px'}")
						i.fa.fa-remove(@click="removeGlobalSearchFilter")
					ProjectsGlobalSearch(:parent="'#global-search-wrapper'" :searchValue="globalSearchFilter")

			.device-control(v-if="Template.SelectedTemplate.id !== 5")
				.control-button
					.icon.r16-9(:class="{selected: currentDevice === '16:9', portrait: devices['16:9'].orientation === 'portrait'}" v-on:click="setDevice('16:9')" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: '1920 x 1080 resolution', html: true}")
				.control-button
					.icon.r16-10(:class="{selected: currentDevice === '16:10', portrait: devices['16:10'].orientation === 'portrait'}" v-on:click="setDevice('16:10')" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: '1920 x 1200 resolution', html: true}")
				.control-button
					.icon.r21-9(:class="{selected: currentDevice === '21:9', portrait: devices['21:9'].orientation === 'portrait'}" v-on:click="setDevice('21:9')" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: '2560 x 1080 resolution', html: true}")
				.control-button
					.icon.r4-3(:class="{selected: currentDevice === '4:3', portrait: devices['4:3'].orientation === 'portrait'}" v-on:click="setDevice('4:3')" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: '1024 x 768 resolution', html: true}")
			.device-control(v-if="Template.SelectedTemplate.id === 5")
				.control-button
					.icon.mobile.iphone(:class="{selected: currentDevice === '9:16', landscape: devices['9:16'].orientation === 'landscape'}" v-on:click="setDevice('9:16')" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: '1080 x 1920 resolution', html: true}")
				.control-button
					.icon.mobile.ipad(:class="{selected: currentDevice === '3:4', landscape: devices['3:4'].orientation === 'landscape'}" v-on:click="setDevice('3:4')" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: '2048 x 2732 resolution', html: true}")
				.control-button
					.icon.mobile.iphonex(:class="{selected: currentDevice === '6:13', landscape: devices['6:13'].orientation === 'landscape'}" v-on:click="setDevice('6:13')" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: '1125 x 2436 resolution', html: true}")

			//.overlay-controls
				input.custom-range(type="range" :min="0" :max="100" :step="1" :value="overlayOpacity" v-on:input="setOverlayTransparency(parseInt($event.target.value))" v-b-tooltip.hover="{delay: { show: 1500, hide: 100 }, title: 'Transparency of overlay', html: true}")
				.control-button-separator(v-if="Layout.layout === 'dashboard'" :style="{marginRight: '15px'}")
			.right-controls
				//.control-button(v-if="Layout.layout === 'dashboard'" v-on:click="save()" :class="{disabled: !Project.SelectedProject.changed}" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Save settings'}")
					i.fa.fa-save
				//--.control-button(v-if="Layout.layout === 'dashboard'" v-on:click="copy()" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Duplicate settings'}")
					i.fa.fa-copy
				.control-button(v-if="Layout.layout === 'dashboard'" v-on:click="deleteProject()" v-b-tooltip.hover.v-danger="{delay: { show: 500, hide: 100 }, title: 'Delete project'}")
					i.fa.fa-remove
				.control-button-separator(v-if="Layout.layout === 'dashboard'")
				.control-button(v-if="Layout.layout === 'dashboard'")
					DownloadButton
				.control-button(v-if="Layout.layout === 'dashboard'")
					UploadButton
				.control-button(v-on:click="refresh(1)" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Reload creative'}")
					i.fa.fa-refresh
		.preview-frame(:style="dimensions" v-show="isShowIframe")
			iframe(ref="iframe" frameborder="0" :width="'100%'" :height="'100%'" allow="autoplay; encrypted-media; picture-in-picture")
</template>

<script>

	import DownloadButton 				from './../../components/Header/DownloadButton'
	import UploadButton 				from './../../components/Header/UploadButton'
	import ProjectsGlobalSearch 		from "./../../components/Project/ProjectsGlobalSearch";

	import Screen 						from './../../mixins/screen'

	import { Metadata } 				from './../../services/Metadata'

	import { Layout } 					from './../../services/Layout'
	import { Template }					from './../../services/Template'
	import { Project }					from './../../services/Project'

	import { Settings }					from './../../services/Settings'
	import { Asset }					from './../../services/Asset'
	import { Section }					from './../../services/Section'

	export default {
		name: 'Preview',
		mixins: [Screen],
		screen: {
			updateOn: ["Selected Project Changed", "Layout Changed"],
			events: {
				"Metadata Loaded": function() {

					this.refresh(10);

				},
				"Selected Project Changed": function() {

					this.refresh(100);

				},
				"Aside State Changed": function() {

					this.processFrameSize();

				},

				"Section Created": function(section) {

					this.refresh(1);

				},

				"Section Removed": function(section) {

					this.refresh(100);

				},

				"Selected Template Changed": function(id) {
					if (id === 5) {
						this.devices['9:16'].width = 414;
						this.devices['9:16'].height = 736;
						this.devices['9:16'].ratio = 9/16;
						this.devices['9:16'].orientation = 'portrait';
						this.setDevice('9:16');
					} else {
						this.setDevice('16:9');
					}
				},

				"Selected Project Sections Changed": function(sections) {

					let message = {
						sections: {}
					};

					_.each(sections, section => {

						message.sections[section['id']] = section;

					});

					if (this.$refs.iframe) {

						this.$refs.iframe.contentWindow.postMessage(message, '*');

						console.log('Send to IFrame >> ', message);

					}

				},
				"Asset Changed": function(asset_id, asset_codename) {

					let message = {
						assets: {}
					};

					message.assets[asset_codename] = Asset.getMergedAsset(Asset.Assets[asset_id]);

					let asset = Asset.Assets[asset_id];

					let sections = Section.getSelectedProjectSectionsById();

					Object.values(sections).forEach(section => {

						if (section.type === 'image' && section.Data.assetId === asset_id) {

							this.getMeta(section, Asset.Assets[section.Data.assetId].mergedAssetData.url);

						}

					});

					if (this.$refs.iframe) {

						this.$refs.iframe.contentWindow.postMessage(message, '*');

						console.log('Send to IFrame >> ', message);

					}

				},
				"Setting Changed": function(setting) {

					let message = {
						settings: {}
					};

					message.settings[setting['codename']] = setting;

					if (this.$refs.iframe) {

						this.$refs.iframe.contentWindow.postMessage(message, '*');

						console.log('Send to IFrame >> ', message);

						if (Template.SelectedTemplate.id === 9 && (setting.codename === 'banner-width' || setting.codename === 'banner-height')) {
							Template.updateBannerIFrameSize();
						}

					}

				},
				"Send to IFrame": function(message) {

					if (this.$refs.iframe) {

						this.$refs.iframe.contentWindow.postMessage(message, '*');

						console.log('Send to IFrame >> ', message);

					}

				},
				"Preview Refresh": function() {
					this.refresh(500);
				}
			}
		},
		components: {
			DownloadButton,
			UploadButton,
			ProjectsGlobalSearch
		},
		data() {

			this.Template = Template;
			this.Project = Project;
			this.Settings = Settings;
			this.Layout = Layout;
			this.Metadata = Metadata;

			return {
				showed: true,
				domain: 'none',
				isShowIframe: false,
				currentDevice: '16:9',
				devices: {
					'16:9': {
						width: 1920,
						height: 1080,
						ratio: 16/9,
						text: ['16', '9'],
						orientation: 'landscape'
					},
					'16:10': {
						width: 1920,
						height: 1200,
						ratio: 16/10,
						text: ['16', '10'],
						orientation: 'landscape'
					},
					'21:9': {
						width: 2560,
						height: 1080,
						ratio: 21/9,
						text: ['19.5', '9'],
						orientation: 'landscape'
					},
					'4:3': {
						width: 1024,
						height: 768,
						ratio: 4/3,
						text: ['4', '3'],
						orientation: 'landscape'
					},
					'9:16': {
						width: 414,
						height: 736,
						ratio: 9/16,
						text: ['9', '16'],
						mobile: true,
						orientation: 'portrait'
					},
					'3:4': {
						width: 1024,
						height: 1366,
						ratio: 3/4,
						text: ['3', '4'],
						mobile: true,
						orientation: 'portrait'
					},
					'6:13': {
						width: 375,
						height: 812,
						ratio: 6/13,
						text: ['6', '13'],
						mobile: true,
						orientation: 'portrait'
					}
				},
				windowWidth: 0,
				windowHeight: 0,
				dimensions: {},
				globalSearchFilter: ''
			};

		},
		created() {

			if (Template.SelectedTemplate.id === 5) {
				this.devices['9:16'].width = 414;
				this.devices['9:16'].height = 736;
				this.devices['9:16'].ratio = 9/16;
				this.devices['9:16'].orientation = 'portrait';
				this.setDevice('9:16');
			} else {
				this.setDevice('16:9');
			}
			window.addEventListener('resize', () => {

				this.windowWidth =  window.innerWidth;
				this.windowHeight = window.innerHeight;

				this.processFrameSize();

			});

			window.addEventListener('message', e => {

				//if (e.data.log) console.log(...e.data.log);
				if (e.data === 'script loaded'){

					let overlayTransparency = window.localStorage.getItem('overlay-transparency');
					let settings = Project.getSettings();

					let message = {
						sections: settings.ProjectSections,
						settings: settings.ProjectSettings,
						overlayTransparency: overlayTransparency,

						// Локально ассеты не обновляются т.к. передается на https сайт, а локально отправляется путь ассетов для http домена http://mraidio.com, видимо браузер не дает делать такие запросы
						// assets: settings.ProjectAssets,
					};

					this.$refs.iframe.contentWindow.postMessage(message, '*');

					console.log('Send to IFrame >> ', message);

				}

			});

			this.windowWidth =  window.innerWidth;
			this.windowHeight = window.innerHeight;

			this.processFrameSize();


		},
		destroyed() {

		},
		mounted() {

		},
		methods: {
			setWebsite(domain) {

				this.domain = domain;

				this.refresh(100);

			},
			deleteProject() {

				Broadcast.call("Show Project Actions Delete");

			},
			getMeta(section, url) {
				let img = new Image();
				img.onload = function () {
					let width = this.width || 500;
					let height = this.height || 500;
					Section.saveSectionData(section, ['width', 'height'], [width, height]);
				};
				img.src = url;
			},
			refresh(timeout) {

				clearTimeout(this.refreshTimeout);
				this.refreshTimeout = setTimeout(() => {

					let iframe = this.$refs.iframe;
					if (!iframe) return;

					this.isShowIframe = true;

					let website = Metadata.Websites[this.domain];
					if (website){

						let script = Project.getScript();

						this.$refs.iframe.src = website.url;
						iframe.onload = () => {
							console.log(`${website.url} iframe content loaded`)
						}

					} else {
						let defaultFrameContent = Project.buildDefaultHtml();
						this.$refs.iframe.removeAttribute('src');
						this.$refs.iframe.srcdoc = defaultFrameContent;
					}

					iframe.onload = () => {
						if (Template.SelectedTemplate.id === 9) {
							Template.updateBannerIFrameSize();
						}
					}

					this.$forceUpdate();

				}, timeout || 1000);

			},
			setDevice(device) {

				if (this.currentDevice === device && this.devices[device].mobile) {

					this.devices[this.currentDevice].orientation = this.devices[this.currentDevice].orientation === 'portrait' ? 'landscape' : 'portrait';
					let width = this.devices[this.currentDevice].width;
					let height = this.devices[this.currentDevice].height;
					this.devices[this.currentDevice].width = height;
					this.devices[this.currentDevice].height = width;
					let ratio = device.split(':');
					this.devices[this.currentDevice].ratio = this.devices[this.currentDevice].orientation === 'portrait' ? parseInt(ratio[0]) / parseInt(ratio[1]) : parseInt(ratio[1]) / parseInt(ratio[1]);

				} else {

					this.currentDevice = device;

				}

				this.processFrameSize();

			},
			setOverlayTransparency(value) {

				window.localStorage.setItem('overlay-transparency', value);

				let message = {
					overlayTransparency: value
				};

				this.$refs.iframe.contentWindow.postMessage(message, '*');

				console.log('Send to IFrame >> ', message);

			},
			processFrameSize() {

				const proportions = this.devices[this.currentDevice];

				let proportions_width = proportions.width * 1.2,
					proportions_height = proportions.height * 1.2;

				let frame_width = window.innerWidth,
					frame_height = window.innerHeight;

				//console.log('frame_width', frame_width);

				frame_height -= 54; //header
				frame_height -= 15; //devices

				if (Layout.layout === 'dashboard') frame_width -= Layout.templatesPlaneWidth + Layout.projectsPlaneWidth;
				if (Layout.asideOpened) frame_width -= Layout.asideSize; //aside

				//if (this.devices[this.currentDevice].orientation === 'portrait') [proportions_width, proportions_height] = [proportions_height, proportions_width];

				frame_width -= 40;
				frame_height -= 60;

				let percent = 1;

				if (proportions_height > frame_height) {

					percent = Math.min(percent, frame_height / proportions_height);

					//proportions_height = proportions_height * percent;
					//proportions_width = proportions_width * percent;

				}

				if (proportions_width > frame_width) {

					percent = Math.min(percent, frame_width / proportions_width);

					//proportions_height = proportions_height * percent;
					//proportions_width = proportions_width * percent;

				}

				//console.log('proportions', proportions_width, proportions_height, proportions_width / proportions.width, proportions_height / proportions.height);

				if (this.isFullScreen()) {

					this.dimensions = {
						width: `${this.windowWidth}px`,
						height: `${this.windowHeight}px`,
						transform: `scale(${percent})`,
						transformOrigin: 'center center'
					};

				} else {

					this.dimensions = {
						width: `${Math.floor(proportions_width)}px`,
						height: `${Math.floor(proportions_height)}px`,
						left: `${Math.floor(Layout.templatesPlaneWidth + Layout.projectsPlaneWidth + 20 + (this.windowWidth - Layout.templatesPlaneWidth - Layout.projectsPlaneWidth - 40 - (Layout.asideOpened ? Layout.asideSize : 0) - proportions_width * percent) / 2)}px`,
						top: `120px`,
						transform: `scale(${percent})`,
						transformOrigin: 'top left'
					};

				}

				this.$forceUpdate();

			},
			isFullScreen() {

				const is_mobile_device = (function() {
					let check = false;
					(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
					return check;
				})();

				const is_small_size = this.windowWidth < 512 || this.windowHeight < 512;

				return is_mobile_device || is_small_size;

			},
			removeGlobalSearchFilter() {
				this.globalSearchFilter = '';
			},
			showGlobalSearch() {
				Broadcast.call("Show Projects Global Search");
			}

		},
		computed: {
			overlayOpacity() {

				let value = window.localStorage.getItem('overlay-transparency');

				return value ? parseInt(value) || 0 : 100;

			},

			availableWebsites() {
				return Object.values(Metadata.Websites).filter(website => {
					return website.available_in_dashboard === 1;
				});
			}
		}
	}
</script>

<style lang="sass">

	.preview-screen
		width: 100%
		height: 100%
		text-align: center

		.controls
			background-color: #343b41
			border-bottom: 1px solid #23282c
			position: absolute
			left: 0
			width: 100%
			top: 0
			height: 46px
			text-align: center
			display: flex
			justify-content: center

			.device-control
				display: flex
				width: 180px
				margin-top: 12px
				margin-left: 7px

				.control-button
					display: inline-block
					cursor: pointer
					margin: 0 5px 0 5px
					width: 30px
					height: 30px
					color: #000
					text-align: center
					font-size: 12px
					line-height: 20px

					.icon
						height: 30px
						display: inline-block
						background-size: contain
						background-position: top center
						background-repeat: no-repeat

						&.r16-9
							width: 30px
							background-image: url("../../../public/img/icons/devices/16-9.png")

						&.r16-10
							width: 30px
							background-image: url("../../../public/img/icons/devices/16-10.png")

						&.r21-9
							width: 35px
							background-image: url("../../../public/img/icons/devices/21-9.png")

						&.r4-3
							width: 23px
							background-image: url("../../../public/img/icons/devices/4-3.png")

						&.r16-9.selected
							background-image: url("../../../public/img/icons/devices/16-9-s.png")

						&.r16-10.selected
							background-image: url("../../../public/img/icons/devices/16-10-s.png")

						&.r21-9.selected
							background-image: url("../../../public/img/icons/devices/21-9-s.png")

						&.r4-3.selected
							background-image: url("../../../public/img/icons/devices/4-3-s.png")

						&.mobile
							&.iphone
								width: 16px
								background: url("../../../public/img/icons/devices/device-icon-iphone.png") left no-repeat

							&.ipad
								width: 21px
								background: url("../../../public/img/icons/devices/device-icon-ipad.png") left no-repeat

							&.iphonex
								width: 16px
								background: url("../../../public/img/icons/devices/device-icon-iphonex.png") left no-repeat

							&.selected
								background-position: right

			.left-controls
				display: flex
				flex-direction: row
				position: absolute
				left: 5px
				top: 0
				height: 46px
				line-height: 44px
				color: #e4e7ea
				justify-content: center
				align-items: center

				.global-search-wrapper
					margin-left: 10px

					.global-search
						display: flex
						flex-direction: row
						height: 30px
						align-items: center
						background-color: rgba(255, 255, 255, 0.02)
						border: 1px solid rgba(255, 255, 255, 0.04)
						border-radius: 3px
						transition: border-color 0.35s ease-in-out, box-shadow 0.35s ease-in-out, color 0.35s ease-in-out, -webkit-box-shadow 0.35s ease-in-out

						>i.fa-search, i.fa-remove
							padding: 10px
							transition: opacity 0.35s ease-in-out

						>i.fa-search
							opacity: 0.1
						>i.fa-remove
							opacity: 0
							pointer-events: none

						>input
							border: unset
							color: rgba(255, 255, 255, 0.17)
							background-color: unset
							outline: none
							width: 180px
							transition: color 0.35s ease-in-out
							line-height: 1.5

					&.focused
						.global-search
							border-color: rgba(255, 255, 255, 0.18)
							background-color: rgba(255, 255, 255, 0.10)

							>input
								color: white

							>i.fa-search
								opacity: 1

							&.filter-exists
								>i.fa-remove
									opacity: 1
									pointer-events: auto
									cursor: pointer

				.control-button
					display: inline-block
					cursor: pointer
					margin: 0 5px 0 5px
					width: 30px
					height: 46px
					text-align: center
					line-height: 44px

				.control-button:hover
					color: #fff

				.control-button.disabled
					color: #e4e7ea
					opacity: 0.2

				select
					border: 1px solid #23282c
					background-color: #515b65
					color: #fff
					cursor: pointer

			.overlay-controls
				display: flex
				flex-direction: row
				position: absolute
				right: 205px
				top: 0
				height: 46px
				line-height: 44px
				color: #e4e7ea

				.custom-range
					margin-top: 20px
					margin-right: 10px
					cursor: pointer
					width: 100px
					height: 4px

				input[type=range]::-webkit-slider-thumb
					width: 10px
					height: 10px

				input[type=range]::-moz-range-thumb
					width: 10px
					height: 10px

				input[type=range]::-ms-thumb
					width: 10px
					height: 10px

				input[type=range]::-webkit-slider-runnable-track
					width: 100%
					height: 6px

				input[type=range]::-moz-range-track
					width: 100%
					height: 6px

				input[type=range]::-ms-track
					width: 100%
					height: 6px

			.right-controls
				display: flex
				flex-direction: row
				position: absolute
				right: 5px
				top: 0
				height: 46px
				line-height: 44px
				color: #e4e7ea

				.control-button
					display: inline-block
					cursor: pointer
					margin: 0 5px 0 5px
					width: 30px
					height: 46px
					text-align: center
					line-height: 44px

				.control-button:hover
					color: #fff

				.control-button.disabled
					color: #e4e7ea
					opacity: 0.2

			.icon.portrait
				transform: rotate(-90deg)
			.icon.landscape
				transform: rotate(-90deg)

			.control-button-separator
				display: inline-block
				width: 1px
				height: 25px
				background: rgba(0, 0, 0, 0.2)
				margin: 10px 5px

		.copy-settings
			position: absolute
			top: 0
			right: 0
			width: 150px

		.rotate-message
			color: #73818f
			font-size: 12px
			font-family: Arial, sans-serif
			margin-top: 10px
			cursor: default

		.preview-frame
			position: fixed
			display: inline-block
			border: none
			box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.27), 0px 0px 7px rgba(0, 0, 0, 0.27)
			background-color: #cccccc

	.preview-screen.mobile

		.device-control
			display: none

		.rotate-message
			display: none

		.preview-frame
			border: none
			position: fixed
			left: 0
			top: 0
			z-index: 10000

</style>

